import React from 'react'
import './About.css'

export default function About() {
  return (
    <main id="About"> 
      <h1>Sobre mim</h1>
      <p>
        Atualmente atuo como desenvolvedor front-end junior na Dopster, e estudo
        desenvolvimento fullstack na escola Trybe de programação, procuro cada vez mais 
        me desenvolver na área da programação e alem dos conhecimentos técnicos em programação,
        eu gosto muito de estudar sobre gerenciamento e liderança e busco sempre desenvolver minhas
        soft-skills.
      </p>
    </main>
  )
}
